import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { CSSProperties, computed, inject } from 'vue'
import { sharedDataKey } from '@/components/types'

type Props = {
  width?: CSSProperties['width']
  fullscreenWidth?: CSSProperties['width']
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DividerComponent',
  props: {
    width: { default: 'auto' },
    fullscreenWidth: { default: '100%' }
  },
  setup(__props: any) {

const sharedData = inject(sharedDataKey)
const fullscreen = computed(() => sharedData?.fullscreen ?? false)

const props = __props
const width = computed(() => (fullscreen.value ? props.fullscreenWidth : props.width))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "divider-component",
    style: _normalizeStyle({ width: width.value })
  }, null, 4))
}
}

})